var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSensorSchema(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Sensor_Schema",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 125.903,
    height: 283.674,
    viewBox: "0 0 125.903 283.674",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #Sensor_Schema .cls-1 {\n        fill: none;\n      }\n\n      #Sensor_Schema .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      #Sensor_Schema .cls-3 {\n        fill: #e3e3e3;\n      }\n\n      #Sensor_Schema .cls-4 {\n        fill: #9ea1a2;\n      }\n\n      #Sensor_Schema .cls-5 {\n        fill: #3e4346;\n      }\n\n      #Sensor_Schema .cls-6 {\n        fill: #0a2335;\n      }\n\n      #Sensor_Schema .cls-7 {\n        fill: #c3c3c3;\n      }\n\n      #Sensor_Schema .cls-8 {\n        fill: #c2d74c;\n      }\n\n      #Sensor_Schema .cls-9 {\n        fill: #8021ff;\n      }\n\n      #Sensor_Schema .cls-10 {\n        fill: #006837;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_2441",
    "data-name": "Rechteck 2441",
    className: "cls-1",
    width: 125.903,
    height: 283.674
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2705",
    "data-name": "Gruppe 2705",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2625",
    "data-name": "Pfad 2625",
    className: "cls-3",
    d: "M124.39,121.281l-7.309,2.031-7.308-2.192-7.31,1.066-7.311-2.542-7.309,3.942-7.31-4.489-7.311,4.546-7.312.473-7.307.473-7.31-1.75-7.31-3.145-7.31,3.479L29.361,121l-7.315-1.812-7.313,5.027-7.317-.025L.1,124.635V283.674H125.027s-.913-162.136-.637-162.393"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_2438",
    "data-name": "Rechteck 2438",
    className: "cls-4",
    width: 3.851,
    height: 28.877,
    transform: "translate(113.167 93.716)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2626",
    "data-name": "Pfad 2626",
    className: "cls-5",
    d: "M118.957,86.717V62.138a1.219,1.219,0,0,1,.81-1.168,2.931,2.931,0,0,0,0-5.572,1.22,1.22,0,0,1-.81-1.169,1.253,1.253,0,0,0-1.252-1.252H92.589a1.252,1.252,0,0,0-1.252,1.252v1.035c-.076-.006-.149-.023-.227-.023a2.943,2.943,0,1,0,0,5.886c.078,0,.151-.017.227-.023V87.751c-.076-.006-.149-.023-.227-.023a2.944,2.944,0,0,0,0,5.887c.078,0,.151-.017.227-.023V94.74a1.252,1.252,0,0,0,1.252,1.252h25.116a1.253,1.253,0,0,0,1.252-1.252v-.114a1.219,1.219,0,0,1,.81-1.168,2.932,2.932,0,0,0,0-5.573,1.217,1.217,0,0,1-.81-1.168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2627",
    "data-name": "Pfad 2627",
    className: "cls-6",
    d: "M106.338,42.753V26.264a1.361,1.361,0,1,0-2.722,0V42.753a1,1,0,0,0-.665.937v9.287H107V43.69a1,1,0,0,0-.666-.937"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2628",
    "data-name": "Pfad 2628",
    className: "cls-7",
    d: "M92.9,58.184a1.791,1.791,0,1,1-1.791-1.791A1.791,1.791,0,0,1,92.9,58.184"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2629",
    "data-name": "Pfad 2629",
    className: "cls-7",
    d: "M120.634,58.184a1.791,1.791,0,1,1-1.791-1.791,1.791,1.791,0,0,1,1.791,1.791"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2630",
    "data-name": "Pfad 2630",
    className: "cls-7",
    d: "M92.9,90.672a1.791,1.791,0,1,1-1.791-1.791A1.791,1.791,0,0,1,92.9,90.672"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2631",
    "data-name": "Pfad 2631",
    className: "cls-7",
    d: "M120.634,90.672a1.791,1.791,0,1,1-1.791-1.791,1.791,1.791,0,0,1,1.791,1.791"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2632",
    "data-name": "Pfad 2632",
    className: "cls-6",
    d: "M108.088,102.841h-6.223a3.681,3.681,0,0,1-3.68-3.681V96.049h13.584V99.16a3.681,3.681,0,0,1-3.681,3.681"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2633",
    "data-name": "Pfad 2633",
    className: "cls-6",
    d: "M92.693,186.418l-.094-2c.566-.026,1.12-.041,1.662-.056,5.09-.134,8.162-.216,8.162-9.913V101.2h2v73.252c0,11.645-4.91,11.775-10.109,11.912-.528.015-1.069.029-1.621.055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2634",
    "data-name": "Pfad 2634",
    className: "cls-6",
    d: "M96.378,245.9l-.094-2c.565-.026,1.12-.041,1.661-.056,5.091-.134,8.163-.215,8.163-9.912l-.992-134.088,2-.015.992,134.095c0,11.654-4.911,11.783-10.11,11.919-.528.015-1.068.029-1.62.055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2635",
    "data-name": "Pfad 2635",
    className: "cls-5",
    d: "M.2,126.555,0,123.562l7.422-.488,6.819.025,7.493-5.545,8.013,2.138,6.793,2.175,7.41-3.8,7.85,3.635,6.942,1.788,13.976-.973,7.81-5.226,7.366,4.869,7.119-4.132,7.606,2.847,7.275-1.142,7.2,2.326,6.863-2.052.859,2.874-7.755,2.32-7.412-2.394-7.346,1.154-7.015-2.625-7.5,4.353L80.538,120.9l-6.814,4.561-15.259,1.062-7.8-2.035-6.647-3.078L36.805,125.1l-7.9-2.532-6.545-1.745L15.225,126.1l-7.762-.029Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2636",
    "data-name": "Pfad 2636",
    className: "cls-8",
    d: "M66.973,21.047S34.673,27.221,26.09,47.5,42.136,65.1,42.136,65.1,66.728,78.089,64.793,54.9c-2.059-24.68,2.18-33.851,2.18-33.851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2637",
    "data-name": "Pfad 2637",
    className: "cls-8",
    d: "M2.09,71.225s20.393-7.164,32.594,1.4S32.076,87.8,32.076,87.8s-9.09,15.391-16.443,1.725C7.809,74.982,2.09,71.225,2.09,71.225"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2638",
    "data-name": "Pfad 2638",
    className: "cls-5",
    d: "M68.362,138.981c-3.145-2.51-6.975-4.088-9.938-6.657a117.118,117.118,0,0,1-11.46-11.648l1.368-.058c-.214-12.132-.81-24.142-1.8-36.21-.643-7.975-1.8-15.883-1.655-23.851-.068-12.8,5.129-22.739,14.852-31.457-10.6,8.294-16.524,18.175-17.421,31.326-.909,12.065.312,24.088-.062,36.141-.018,1.378-.045,2.758-.072,4.138C36.4,87.5,26.967,75.479,12.2,73.658c18.6,4.255,25.512,24.129,28.4,40.121.4,2.343.731,4.793.892,7.037a30.3,30.3,0,0,0-5.581,5.387,50.014,50.014,0,0,0-4.854,7.628c-3.732,1.5-7.779,2.618-11.3,3.871-2.687.963-5.5,1.818-7.759,3.574-6.943,5.468-7.146,15.071-5.6,22.838l.978-.2c-1.151-7.233-.783-16.4,5.776-21.228,2.148-1.541,4.8-2.213,7.313-3.032,2.867-.938,6-1.736,9.085-2.7-5.074,11.479-6.289,24.5-6.484,36.786v.005h1.624A116.8,116.8,0,0,1,26.87,154.42a74.426,74.426,0,0,1,6.379-18.756,28.333,28.333,0,0,0,6.674-3.521c-.349,1.422-.656,2.673-.871,3.552a40.56,40.56,0,0,0-.975,4.681q-.636,2.331-1.244,4.668a142.005,142.005,0,0,0-4.446,30.071c-.27,10.167,1.3,20.328,3.191,30.339l.982-.177c-2.139-13.21-3.653-26.815-1.507-40.071.911-5.084,1.342-10.138,2.639-15.16.442,7.708,2.5,15.383,4.908,22.716,3.045,9.9,4.065,20.849.8,30.8l.927.356a39.279,39.279,0,0,0,2.359-10.47,58.905,58.905,0,0,0-2-21.244c-.926-3.413-1.831-6.795-2.541-10.22-1.913-8.586-2.151-17.173.345-25.525.511-1.791,1.449-5.089,2.358-8.286,4.22,3.87,4.861,11.068,5.13,16.311.237,6.717.159,14.081.882,20.764.53,4.6,1.591,9.329,4.254,13.349l.853-.5c-4.8-8.04-3.905-17.764-4.048-26.733-.031-5.606.333-11.812-1.235-17.378A248.7,248.7,0,0,1,62.4,157.35c2.547,6.1,5.2,12.435,4.805,19.1a24.025,24.025,0,0,1-8.7,17.253l.6.764a25.3,25.3,0,0,0,9.718-17.917c.633-6.929-1.876-13.584-4.33-19.977a257.248,257.248,0,0,0-12.523-26.59c1.572,1.409,3.173,2.791,4.846,4.111,4.658,3.686,11.118,5.133,14.238,10.317,1.962,3.188,2.406,7.12,2.307,10.923l1,.049c.613-5.922-.774-12.591-6-16.407M41.331,126.41a16.055,16.055,0,0,1-5.666,5.2,31.629,31.629,0,0,1,6.049-6.765l-.383,1.562m4.251-.8c.025-.086.048-.168.072-.253.11.182.222.363.331.546-.127-.106-.269-.194-.4-.293"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_2439",
    "data-name": "Rechteck 2439",
    width: 27.582,
    height: 0.5,
    transform: "translate(3.874 185.179)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2639",
    "data-name": "Pfad 2639",
    d: "M5.237,183.5v-6.639H3.321V176.1h.117a2.2,2.2,0,0,0,1.447-.41,1.7,1.7,0,0,0,.534-1.266H6.21V183.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2640",
    "data-name": "Pfad 2640",
    d: "M8.946,179.036a8.075,8.075,0,0,1,.563-3.571,1.965,1.965,0,0,1,1.875-1.034,2.123,2.123,0,0,1,1.133.29,2.387,2.387,0,0,1,.812.894,3.778,3.778,0,0,1,.375,1.253,15.66,15.66,0,0,1,.117,2.18,8.264,8.264,0,0,1-.557,3.574,1.923,1.923,0,0,1-1.845,1.061,2,2,0,0,1-1.908-1.037,8.188,8.188,0,0,1-.565-3.61m1.043-.023A9.465,9.465,0,0,0,10.3,182a1.111,1.111,0,0,0,1.093.8,1.083,1.083,0,0,0,1.081-.724,9.676,9.676,0,0,0,.3-3.055,9.208,9.208,0,0,0-.31-2.948,1.159,1.159,0,0,0-2.174-.032,9.278,9.278,0,0,0-.3,2.968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2641",
    "data-name": "Pfad 2641",
    d: "M21.345,181.123h.926a2.86,2.86,0,0,1-.563,1.893,1.962,1.962,0,0,1-1.588.668,1.82,1.82,0,0,1-1.667-.885,5.338,5.338,0,0,1-.542-2.719,4.921,4.921,0,0,1,.563-2.634,1.892,1.892,0,0,1,1.7-.87,1.96,1.96,0,0,1,1.491.577,2.194,2.194,0,0,1,.548,1.574v.14H21.3a1.914,1.914,0,0,0-.305-1.078.914.914,0,0,0-.779-.369,1.016,1.016,0,0,0-.987.612,5.214,5.214,0,0,0-.3,2.083,5.276,5.276,0,0,0,.3,2.107,1.026,1.026,0,0,0,1,.618.918.918,0,0,0,.814-.44,2.434,2.434,0,0,0,.3-1.277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2642",
    "data-name": "Pfad 2642",
    d: "M23.6,183.5v-6.744h.873v.814a1.864,1.864,0,0,1,.724-.726,2.151,2.151,0,0,1,1.051-.246,1.643,1.643,0,0,1,.941.252,1.287,1.287,0,0,1,.513.732,1.913,1.913,0,0,1,1.752-.984,1.722,1.722,0,0,1,1.256.427,1.649,1.649,0,0,1,.437,1.231V183.5h-.973v-4.658a2.033,2.033,0,0,0-.211-1.111.853.853,0,0,0-.738-.29,1.306,1.306,0,0,0-1.365,1.366V183.5h-.973v-4.693a1.858,1.858,0,0,0-.225-1.055.863.863,0,0,0-.748-.311,1.389,1.389,0,0,0-1,.37,1.255,1.255,0,0,0-.386.949v4.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2643",
    "data-name": "Pfad 2643",
    className: "cls-9",
    d: "M112.469,23.318a2.024,2.024,0,0,1-1.432-.593,8.939,8.939,0,0,0-12.347,0,2.025,2.025,0,0,1-2.863-2.864,12.781,12.781,0,0,1,18.074,0,2.025,2.025,0,0,1-1.432,3.457"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2644",
    "data-name": "Pfad 2644",
    className: "cls-9",
    d: "M118.174,17.613a2.022,2.022,0,0,1-1.432-.593,16.818,16.818,0,0,0-23.756,0,2.026,2.026,0,0,1-2.865-2.864,20.879,20.879,0,0,1,29.484,0,2.025,2.025,0,0,1-1.431,3.457"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2645",
    "data-name": "Pfad 2645",
    className: "cls-9",
    d: "M123.878,11.91a2.024,2.024,0,0,1-1.432-.593,24.9,24.9,0,0,0-35.166,0,2.025,2.025,0,1,1-2.863-2.864,28.954,28.954,0,0,1,40.893,0,2.025,2.025,0,0,1-1.432,3.457"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2646",
    "data-name": "Pfad 2646",
    className: "cls-10",
    d: "M81.763,181.555v7.318H42.731l-7.071-3.635,7.071-3.683Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2647",
    "data-name": "Pfad 2647",
    className: "cls-3",
    d: "M82.262,189.374H42.611l-8.038-4.133,8.037-4.185H82.262Zm-39.409-1H81.262v-6.318H42.854l-6.1,3.179Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2648",
    "data-name": "Pfad 2648",
    className: "cls-6",
    d: "M98.782,185.192h0a4.142,4.142,0,0,1-4.142,4.142H81.73a3.383,3.383,0,0,1-3.383-3.383v-1.518a3.383,3.383,0,0,1,3.383-3.383H94.64a4.142,4.142,0,0,1,4.142,4.142"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_2440",
    "data-name": "Rechteck 2440",
    width: 27.582,
    height: 0.5,
    transform: "translate(3.874 244.948)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2649",
    "data-name": "Pfad 2649",
    d: "M3.005,243.264Q3,243.206,3,243.135c0-.047,0-.117,0-.211a3.692,3.692,0,0,1,.387-1.664,5.034,5.034,0,0,1,1.189-1.494c.1-.09.248-.221.44-.393a14.91,14.91,0,0,0,1.213-1.154,1.785,1.785,0,0,0,.357-.656,3.069,3.069,0,0,0,.112-.879,1.825,1.825,0,0,0-.346-1.2,1.208,1.208,0,0,0-.985-.416,1.12,1.12,0,0,0-.981.462,2.449,2.449,0,0,0-.325,1.4c.008.133.012.232.012.3H3.093c0-.035,0-.089-.006-.161s-.006-.126-.006-.162a3.029,3.029,0,0,1,.607-2.024,2.132,2.132,0,0,1,1.719-.712,2.245,2.245,0,0,1,1.711.648,2.518,2.518,0,0,1,.616,1.807,4.037,4.037,0,0,1-.121,1.04,2.739,2.739,0,0,1-.383.835,5.955,5.955,0,0,1-1.178,1.149c-.152.121-.268.214-.346.281a7.092,7.092,0,0,0-1.3,1.312,2.055,2.055,0,0,0-.395,1.1h3.8v.926Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2650",
    "data-name": "Pfad 2650",
    d: "M8.946,238.8a8.075,8.075,0,0,1,.563-3.571,1.965,1.965,0,0,1,1.875-1.034,2.123,2.123,0,0,1,1.133.29,2.387,2.387,0,0,1,.812.894,3.778,3.778,0,0,1,.375,1.253,15.66,15.66,0,0,1,.117,2.18,8.264,8.264,0,0,1-.557,3.574,1.923,1.923,0,0,1-1.845,1.061,2,2,0,0,1-1.908-1.037,8.188,8.188,0,0,1-.565-3.61m1.043-.023a9.465,9.465,0,0,0,.313,2.991,1.111,1.111,0,0,0,1.093.8,1.083,1.083,0,0,0,1.081-.724,9.676,9.676,0,0,0,.3-3.055,9.208,9.208,0,0,0-.31-2.948,1.159,1.159,0,0,0-2.174-.032,9.278,9.278,0,0,0-.3,2.968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2651",
    "data-name": "Pfad 2651",
    d: "M21.345,240.891h.926a2.86,2.86,0,0,1-.563,1.893,1.962,1.962,0,0,1-1.588.668,1.82,1.82,0,0,1-1.667-.885,5.338,5.338,0,0,1-.542-2.719,4.921,4.921,0,0,1,.563-2.634,1.892,1.892,0,0,1,1.7-.87,1.96,1.96,0,0,1,1.491.577,2.194,2.194,0,0,1,.548,1.574v.14H21.3a1.914,1.914,0,0,0-.305-1.078.914.914,0,0,0-.779-.369,1.016,1.016,0,0,0-.987.612,5.214,5.214,0,0,0-.3,2.083,5.276,5.276,0,0,0,.3,2.107,1.026,1.026,0,0,0,1,.618.918.918,0,0,0,.814-.44,2.434,2.434,0,0,0,.3-1.277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2652",
    "data-name": "Pfad 2652",
    d: "M23.6,243.27v-6.744h.873v.814a1.864,1.864,0,0,1,.724-.726,2.151,2.151,0,0,1,1.051-.246,1.643,1.643,0,0,1,.941.252,1.287,1.287,0,0,1,.513.732,1.913,1.913,0,0,1,1.752-.984,1.722,1.722,0,0,1,1.256.427,1.649,1.649,0,0,1,.437,1.231v5.244h-.973v-4.658a2.033,2.033,0,0,0-.211-1.111.853.853,0,0,0-.738-.29,1.306,1.306,0,0,0-1.365,1.366v4.693h-.973v-4.693a1.858,1.858,0,0,0-.225-1.055.863.863,0,0,0-.748-.311,1.389,1.389,0,0,0-1,.37,1.255,1.255,0,0,0-.386.949v4.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2653",
    "data-name": "Pfad 2653",
    className: "cls-10",
    d: "M81.763,241.324v7.318H42.731l-7.071-3.635,7.071-3.683Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2654",
    "data-name": "Pfad 2654",
    className: "cls-3",
    d: "M82.262,249.142H42.611l-8.038-4.133,8.037-4.185H82.262Zm-39.409-1H81.262v-6.318H42.854L36.749,245Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2655",
    "data-name": "Pfad 2655",
    className: "cls-6",
    d: "M98.782,244.96h0A4.142,4.142,0,0,1,94.64,249.1H81.73a3.383,3.383,0,0,1-3.383-3.383V244.2a3.383,3.383,0,0,1,3.383-3.383H94.64a4.142,4.142,0,0,1,4.142,4.142"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensorSchema);
export default __webpack_public_path__ + "static/media/sensor-schema.8cf09eaeef32efef63b572e9aea5a4fd.svg";
export { ForwardRef as ReactComponent };